<script>
  import { t } from '../../i18n/index.js';

  let { mode = 'simple', disabled = false, onChange } = $props();
</script>

{#if !disabled}
  <div class="mode-toggle mb-4">
    <button
      class="mode-btn {mode === 'simple' ? 'active' : ''}"
      onclick={() => onChange?.('simple')}
    >
      {t('camera.modeSimple')}
    </button>
    <button
      class="mode-btn {mode === 'document' ? 'active' : ''}"
      onclick={() => onChange?.('document')}
    >
      {t('camera.modeDocument')}
    </button>
  </div>
{/if}

<style>
  .mode-toggle {
    display: inline-flex;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 999px;
    padding: 4px;
    gap: 2px;
  }

  .mode-btn {
    padding: 10px 20px;
    border-radius: 999px;
    font-size: 1rem;
    font-weight: 500;
    color: rgba(255,255,255,0.6);
    border: none;
    background: transparent;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 80px;
  }

  .mode-btn.active {
    background: #3b82f6;
    color: white;
    font-weight: 600;
  }
</style>
